import md5 from "js-md5";

import React from "react";

import { useTranslation } from "react-i18next";

import { Link } from "react-router-dom";

export function InternaDaNorma({ data }) {
    const { t } = useTranslation();
    const coresSumario = [
        "#1c84c6",
        "#23c6c8",
        "#1ab394",
        "#f8ac59",
        "#ed5565",
        "#7266ba",
    ];

    const getHash = () => {
        const nomeArquivo = `documento_norma_${data.id}.pdf`;

        return md5(nomeArquivo);
    };

    const markup = { __html: data.descricao };

    return (
        <div className="container p-4 ">
            <div
                style={{
                    marginBottom: "20px",
                }}
            >
                <h3 className="font-weight-bold">{data.nome}</h3>

                <div className="d-flex align-items-center mt-2">
                    <div className="badge badge-primary mr-2">{data.tipo} </div>

                    <div className="badge badge-secondary mr-2 mt-2">
                        {data.areaatuacao_nome}
                    </div>

                    {data.data_conteudo ? (
                        <div className="badge badge-light text-dark">
                            {data.data_conteudo}
                        </div>
                    ) : (
                        <></>
                    )}
                </div>

                {data.resumo && <p className="mt-3">{data.resumo} </p>}
                <hr
                    sytle={{
                        border: "0",
                        height: "1px",
                        backgroundColor: "#ccc",
                        margin: "20px 0",
                    }}
                />

                {data.descricao && (
                    <div
                        dangerouslySetInnerHTML={markup}
                        className="p-3 bg-white shadow-sm"
                        style={{ borderRadius: "1rem" }}
                    />
                )}

                {data.sumarios_relacionados &&
                    data.sumarios_relacionados.length > 0 && (
                        <div
                            className="d-flex flex-wrap align-items-center mt-3"
                            style={{ gap: "6px" }}
                        >
                            {data.sumarios_relacionados.map((sumario, index) => (
                                <span
                                    key={sumario.id}
                                    style={{
                                        display: "inline-block",
                                        padding: "5px 10px",
                                        borderRadius: "12px",
                                        backgroundColor:
                                            coresSumario[
                                                index % coresSumario.length
                                            ],
                                        color: "#fff",
                                        fontSize: "12px",
                                        fontWeight: "700",
                                        lineHeight: "1.2",
                                    }}
                                >
                                    {sumario.nome}
                                </span>
                            ))}
                        </div>
                    )}

                {(data.descricao ||
                    (data.sumarios_relacionados &&
                        data.sumarios_relacionados.length > 0)) && (
                    <hr
                        sytle={{
                            border: "0",
                            height: "1px",
                            backgroundColor: "#ccc",
                            margin: "20px 0",
                        }}
                    />
                )}

                {data.normas_associadas &&
                    data.normas_associadas.length > 0 && (
                        <div
                            style={{
                                marginTop: "20px",
                                marginBottom: "15px",
                                border: "1px solid #ddd",
                                padding: "15px",
                                backgroundColor: "#f9f9f9",
                                textAlign: "left",
                                borderRadius: "4px",
                            }}
                        >
                            <h4
                                style={{
                                    marginTop: "0",
                                    marginBottom: "15px",
                                    fontWeight: "bold",
                                    color: "#333",
                                    fontFamily: "Calibri, sans-serif",
                                }}
                            >
                                Normas Relacionadas
                            </h4>

                            {data.normas_associadas.map(
                                (relacionada, index) => (
                                    <div key={relacionada.id}>
                                        {index > 0 && (
                                            <hr
                                                style={{
                                                    border: "0",
                                                    borderTop: "1px solid #eee",
                                                    margin: "10px 0",
                                                }}
                                            />
                                        )}

                                        <div
                                            style={{
                                                paddingTop: "5px",
                                                paddingBottom: "5px",
                                            }}
                                        >
                                            <Link
                                                to={`/documento/norma/${relacionada.id}`}
                                                style={{
                                                    textDecoration: "none",
                                                }}
                                            >
                                                <b style={{ color: "#043A5E" }}>
                                                    {" "}
                                                    {relacionada.nome}
                                                </b>
                                            </Link>

                                            {relacionada.resumo && (
                                                <p
                                                    style={{
                                                        fontSize: "14px",
                                                        marginTop: "5px",
                                                        marginBottom: "10px",
                                                        color: "#555",
                                                    }}
                                                >
                                                    {relacionada.resumo}
                                                </p>
                                            )}

                                            <div style={{ marginTop: "5px" }}>
                                                <a
                                                    href={relacionada.url_pdf}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        fontSize: "14px",
                                                        color: "#337ab7",
                                                        textDecoration: "none",
                                                    }}
                                                >
                                                    Visualizar PDF (Relacionada)
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ),
                            )}
                        </div>
                    )}

                {data.resenha_descricao && (
                    <p className="mt-3">{data.resenha_descricao} </p>
                )}

                <a
                    className="mr-3 d-flex"
                    style={{
                        cursor: "pointer",
                        color: "#1ab394",
                        marginTop: "10px",
                    }}
                    href={`http://www.taxupdate.co/norma/pdf/${data.id}/${getHash(
                        data.id,
                    )}/?view=1`}
                    target="_blank"
                    rel="noreferrer"
                >
                    {t("interna.clickDownload")}
                </a>
            </div>

            <iframe
                src={`https://www.taxupdate.co/norma/pdf/${data.id}/${getHash(
                    data.id,
                )}/?view=1`}
                width="100%"
                height="600px"
                title="pdf"
            ></iframe>
        </div>
    );
}
